const resultTypes = [
  {
    type: 'pass-fail',
    label: 'Pass/Fail'
  },
  {
    type: 'score',
    label: 'Score'
  },
  {
    type: 'place',
    label: 'Place'
  }];

const nationals = {
  1: 'nswisa',
  2: 'dsa',
  3: 'kanga',
  4: 'unisyd',
  5: 'broome',
  6: 'fencing',
  7: 'eagletag',
  9: 'oztag',
  10: 'fencingnsw',
  11: 'utas',
  12: 'handball',
  14: 'gridiron',
  15: 'archery',
  16: 'volleyball',
  17: 'auckland',
  18: 'oztagau',
  19: 'georgia',
  20: 'bonduni',
  22: 'unisport'
};

const errormsg = {
  required: 'Field is required',
  dateRequired: 'Date is required',
  selectRequired: 'Please select an option',
  phone: 'Please enter a valid number',
  email: 'Please enter a valid email',
  password: 'Password must be at least 8 characters with uppercase letters, lowercase letters and special characters.',
  image_format: 'Please upload jpg, png, jpeg files only',
  file_size: 'File size too big, max 5mb',
};

const productTypes = [
  {
    name: 'Individual',
    type: 'indv'
  },
  {
    name: 'Team',
    type: 'team'
  },
  {
    name: 'Individual To Team',
    type: 'indv-to-team'
  },
  {
    name: 'Entity',
    type: 'entity'
  },
  {
    name: 'Family',
    type: 'family'
  }
];

// Additional question types
const additionalQTypes = [
  {
    name: 'Input',
    type: 1,
  },
  {
    name: 'Dropdown',
    type: 2,
  },
  {
    name: 'File Upload',
    type: 3,
  }
];

const uploadURL = `${process.env.VUE_APP_API_URL}/assemble/api/v1/portal/logos/upload`;

// File upload accepts
const fileUploadAccepts = [
  'image/apng',
  'image/bmp',
  'image/gif',
  'image/jpeg',
  'image/pjpeg',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'image/webp',
  'image/x-icon',
  'text/plain',
  'audio/flac',
  'audio/mpegurl',
  'audio/mpegurl',
  'audio/x-m4a',
  'audio/m4a',
  'audio/mp4',
  'audio/mp4',
  'audio/mpeg',
  'audio/ogg',
  'audio/ogg',
  'audio/x-scpls',
  'audio/wav',
  'audio/aac',
  'application/json',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/css',
  'text/csv',
  'text/html',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/xml',
  'text/xml',
  'application/pdf',
];

const fileUploadAcceptString = fileUploadAccepts.join(',');

// Saleable Item types
const saleableItemTypes = [
  {
    name: 'Shirt',
    type: 1
  },
  {
    name: 'Other',
    type: 0
  },
];

const countries = [
  'Unspecified',
  'Australia',
  'New Zealand',
  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, The Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  'Cote D\'Ivoire',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'England',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and Mcdonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic Of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea, Democratic People\'s Republic of',
  'Korea, Republic of',
  'Kuwait',
  'Kosovo',
  'Kyrgyzstan',
  'Lao People\'s Democratic Republic',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, The Former Yugoslav Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russian Federation',
  'RWANDA',
  'Saint Helena',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Scotland',
  'Senegal',
  'Serbia and Montenegro',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Surilabel',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Viet Nam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wales',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
].map((x) => ({ label: x, value: x }));

const genders = [
  {
    label: 'Male',
    value: 'Male'
  },
  {
    label: 'Female',
    value: 'Female'
  },
  {
    label: 'Other',
    value: 'Other'
  }
];

const states = [
  'New South Wales',
  'Queensland',
  'South Australia',
  'Tasmania',
  'Victoria',
  'Western Australia',
  'Australian Capital Territory',
  'Northern Territory'
].map((x) => ({ label: x, value: x }));

const allSizes = [
  {
    label: 'Kids',
    options: [
      {
        label: '6',
        value: 'kid-6',
      },
      {
        label: '8',
        value: 'kid-8',
      },
      {
        label: '10',
        value: 'kid-10',
      },
      {
        label: '12',
        value: 'kid-12',
      },
      {
        label: '14',
        value: 'kid-14',
      },
      {
        label: '16',
        value: 'kid-16',
      },
    ],
  },
  {
    label: 'Adults',
    options: [
      {
        label: 'XS',
        value: 'adult-xs',
      },
      {
        label: 'Small',
        value: 'adult-s',
      },
      {
        label: 'Medium',
        value: 'adult-m',
      },
      {
        label: 'Large',
        value: 'adult-l',
      },
      {
        label: 'XL',
        value: 'adult-xl',
      },
      {
        label: '2XL',
        value: 'adult-2xl',
      },
      {
        label: '3XL',
        value: 'adult-3xl',
      },
      {
        label: '4XL',
        value: 'adult-4xl',
      },
      {
        label: '5XL',
        value: 'adult-5xl',
      },
      {
        label: '6XL',
        value: 'adult-6xl',
      },
    ],
  },
  {
    label: 'Ladies',
    options: [
      {
        label: '6',
        value: 'ladies-6',
      },
      {
        label: '8',
        value: 'ladies-8',
      },
      {
        label: '10',
        value: 'ladies-10',
      },
      {
        label: '12',
        value: 'ladies-12',
      },
      {
        label: '14',
        value: 'ladies-14',
      },
      {
        label: '16',
        value: 'ladies-16',
      },
      {
        label: '18',
        value: 'ladies-18',
      },
      {
        label: '20',
        value: 'ladies-20',
      },
      {
        label: '22',
        value: 'ladies-22',
      },
      {
        label: '24',
        value: 'ladies-24',
      },
    ],
  }
];

const adultSizes = [
  {
    label: 'Adult',
    options: [
      {
        label: 'XS',
        value: 'adult-xs',
      },
      {
        label: 'S',
        value: 'adult-s',
      },
      {
        label: 'M',
        value: 'adult-m',
      },
      {
        label: 'L',
        value: 'adult-l',
      },
      {
        label: 'XL',
        value: 'adult-xl',
      },
      {
        label: 'XXL',
        value: 'adult-2xl',
      },
      {
        label: 'XXXL',
        value: 'adult-3xl',
      },
    ]
  }
];

const weatherCodes = [
  { value: 0, label: 'Unknown' },
  { value: 1000, label: 'Clear', icon: 'clear_day' },
  { value: 1001, label: 'Cloudy', icon: 'cloudy' },
  { value: 1100, label: 'Mostly Clear', icon: 'mostly_clear_day' },
  { value: 1101, label: 'Partly Cloudy', icon: 'party_cloudy_day' },
  { value: 1102, label: 'Mostly Cloudy', icon: 'mostly_cloudy' },
  { value: 2000, label: 'Fog', icon: 'fog' },
  { value: 2100, label: 'Light Fog', icon: 'fog_light' },
  { value: 3000, label: 'Light Wind', icon: 'wind_light' },
  { value: 3001, label: 'Wind', icon: 'wind' },
  { value: 3002, label: 'Strong Wind', icon: 'wind' },
  { value: 4000, label: 'Drizzle', icon: 'drizzle' },
  { value: 4001, label: 'Rain', icon: 'rain' },
  { value: 4200, label: 'Light Rain', icon: 'rain_light' },
  { value: 4201, label: 'Heavy Rain', icon: 'rain_heavy' },
  { value: 5000, label: 'Snow', icon: 'snow' },
  { value: 5001, label: 'Flurries', icon: 'flurries' },
  { value: 5100, label: 'Light Snow', icon: 'snow_light' },
  { value: 5101, label: 'Heavy Snow', icon: 'snow_heavy' },
  { value: 6000, label: 'Freezing Drizzle', icon: 'freezing_drizzle' },
  { value: 6001, label: 'Freezing Rain', icon: 'freezing_rain' },
  { value: 6200, label: 'Light Freezing Rain', icon: 'freezing_rain_light' },
  { value: 6201, label: 'Heavy Freezing Rain', icon: 'freezing_rain_heavy' },
  { value: 7000, label: 'Ice Pellets', icon: 'ice_pellets' },
  { value: 7101, label: 'Heavy Ice Pellets', icon: 'ice_pellets_heavy' },
  { value: 7102, label: 'Light Ice Pellets', icon: 'ice_pellets_light' },
  { value: 8000, label: 'Thunderstorm', icon: 'tstorm' },
];
const matchStatus = () => {
  let rs = [
    { value: 'pre-game', label: 'Pre-Game' },
    { value: 'final', label: 'Final' },
    { value: 'forfeit', label: 'Forfeit' },
    { value: 'disputed', label: 'Disputed' },
    { value: 'washout', label: 'Washout' },
  ];

  // eslint-disable-next-line eqeqeq
  if (process.env.VUE_APP_NATIONAL_ID == 1) {
    rs = rs.concat([
      { value: 'first-quarter', label: 'First Quarter' },
      { value: 'second-quarter', label: 'Second Quarter' },
      { value: 'third-quarter', label: 'Third Quarter' },
      { value: 'fourth-quarter', label: 'Fourth Quarter' },
    ]);
  } else {
    rs = rs.concat([
      { value: 'first-half', label: 'First Half' },
      { value: 'second-half', label: 'Second Half' },
    ]);
  }
  return rs;
};
const memberTypeTiles = [
  {
    title: 'Coach',
    value: 'coach',
    icon: 'fa-chalkboard-user',
    description: '',
    imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
    selected: false
  },
  {
    title: 'Manager',
    value: 'manager',
    icon: 'suitcase',
    description: '',
    imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
    selected: false
  },
  {
    title: 'Official',
    value: 'official',
    icon: 'whistle',
    description: '',
    imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
    selected: false
  },
  {
    title: 'Player',
    value: 'player',
    icon: 'shirt',
    description: '',
    imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
    selected: false
  },
  {
    title: 'Volunteer',
    value: 'volunteer',
    icon: 'hand',
    description: '',
    imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
    selected: false
  }
];
const regoTypeTiles = [
  {
    title: 'Join a Team',
    value: 'participate',
    description: '',
    icon: 'fa-user-plus',
    imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
    selected: false
  },
  {
    title: 'Become a Member',
    value: 'membership',
    description: '',
    icon: 'fa-badge-check',
    imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
    selected: false
  },
  {
    title: 'Register a team or organisation',
    value: 'team',
    description: '',
    icon: 'fa-people-group',
    imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
    selected: false
  },
  {
    title: 'Register myself to an event or competition',
    value: 'event',
    description: '',
    icon: 'trophy',
    imgSrc: 'https://www.flaticon.com/svg/static/icons/svg/2922/2922510.svg',
    selected: false
  }
];
module.exports = {
  errormsg,
  productTypes,
  additionalQTypes,
  saleableItemTypes,
  countries,
  genders,
  matchStatus: matchStatus(),
  adultSizes,
  allSizes,
  states,
  nationals,
  resultTypes,
  fileUploadAcceptString,
  weatherCodes,
  uploadURL,
  fileUploadAccepts,
  memberTypeTiles,
  regoTypeTiles
};
